import type { ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { useMe } from '@/hooks/use-me';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Sprint 11 (§9.1): Oversight pages for Supervisors with viewTeam (and Admins). Everyone else sees Not
 * found. Access comes from GET /api/me; the API is the real enforcement (requireProjectCapability).
 */
export function OversightRoute({ children, need = 'oversight' }: { children: ReactNode; need?: 'oversight' | 'notes' | 'attendance' }): JSX.Element {
  const { data: me, isLoading } = useMe();
  if (isLoading) {
    return (
      <div className="space-y-3 p-4 sm:p-6" data-testid="oversight-route-loading">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }
  // Sprint 12: the Notes page needs me.access.notes instead (a note capability on some project).
  // Sprint 13: Attendance needs me.access.attendance.
  const allowed = need === 'oversight' ? me?.access.oversight === true : me?.access[need] === true;
  if (!me || (me.role !== 'admin' && !allowed)) return <NotFoundPage />;
  return <>{children}</>;
}
